<template>
  <div class="h-full">
    <div class="space-y-3">
      <UButton
        data-test="favorites-button"
        variant="outline"
        color="neutral"
        size="xl"
        block
        class="py-8 hover:bg-gray-50"
        @click="handleSelectFavorites"
      >
        <div class="flex items-center gap-3 w-full">
          <UIcon name="i-heroicons-heart" class="text-2xl text-red-500" />
          <div class="text-left">
            <TText variant="semibold" color="text-gray-900" classes="mb-0">
              {{ t('outings.favorite_modal.favorites_title') }}
            </TText>
            <TText size="sm" color="text-gray-600" classes="mb-0">
              {{ t('outings.favorite_modal.favorites_description') }}
            </TText>
          </div>
        </div>
      </UButton>

      <UButton
        data-test="outings-button"
        variant="outline"
        color="neutral"
        size="xl"
        block
        class="hover:bg-gray-50 py-8"
        @click="handleSelectOutings"
      >
        <div class="flex items-center gap-3 w-full">
          <UIcon
            name="i-heroicons-globe-europe-africa"
            class="text-2xl text-primary-500"
          />
          <div class="text-left">
            <TText variant="semibold" color="text-gray-900" classes="mb-0">
              {{ t('outings.favorite_modal.outings_title') }}
            </TText>
            <TText size="sm" color="text-gray-600" classes="mb-0">
              {{ t('outings.favorite_modal.outings_description') }}
            </TText>
          </div>
        </div>
      </UButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  selectFavorites: []
  selectOutings: []
}>()

const handleSelectFavorites = () => {
  emit('selectFavorites')
}

const handleSelectOutings = () => {
  emit('selectOutings')
}
</script>
